import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSubscription } from "../hooks/useSubscription";
import UpgradeModal from "./UpgradeModal";
import LoadingSpinner from "./LoadingSpinner";

/**
 * PlanProtectedRoute Component
 * Restricts access to routes based on subscription plan
 * Free plan: Only Settings and CRO Analyzer
 * Paid plans: All routes
 */
const PlanProtectedRoute = ({ children, feature }) => {
  const { loading, canAccessFeature } = useSubscription();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {
    if (!loading) {
      const access = canAccessFeature(feature);
      setHasAccess(access);
      if (!access) {
        setShowUpgradeModal(true);
      }
    }
  }, [loading, feature, canAccessFeature]);

  if (loading) {
    return <LoadingSpinner />;
  }

  // If user doesn't have access, show upgrade modal
  // Then redirect to CRO Analyzer (allowed page)
  if (hasAccess === false) {
    return (
      <>
        <UpgradeModal
          isOpen={showUpgradeModal}
          onClose={() => {
            setShowUpgradeModal(false);
          }}
          feature="route_access"
        />
        <Navigate to="/cro-analyzer" replace />
      </>
    );
  }

  return children;
};

export default PlanProtectedRoute;
